<template>
  <div class="no-print">
    <div class="row map-container">
      <div class="col-12 mb-3">
        <GoogleMap
          ref="map_ref"
          api-key="AIzaSyC2nwmesDNYChq5aFblDMqN1dnv_2q48iM"
          style="width: 100%; height: 500px"
          map-type-id="satellite"
          :center="map_center"
          :zoom="map_zoom"
          :fit-bounds="{}"
          @click="setNewPositionMarker"
        >
          <Marker
            v-for="map_marker in map_markers"
            :key="map_marker.id"
            :options="map_marker"
            @click="selectMarker(map_marker)"
          />
        </GoogleMap>
      </div>
    </div>
    <div class="to-map btn btn-secondary">Voltar ao mapa</div>
  </div>
</template>

<script>
  import { ref, watchEffect } from 'vue'
  import { GoogleMap, Marker } from 'vue3-google-map'
  import { format, parse as parseDate, compareAsc } from 'date-fns'
  import useConfinedSpaces from '@/modules/ConfinedSpace.js'
  import useSwal from '@/modules/Swal.js'
  import $ from 'jquery'

  export default {
    components: {
      GoogleMap,
      Marker,
    },
    setup() {
      const loading = ref(true)
      const map_ref = ref(null)
      const map_center = { lat: -13.70576, lng: -69.6477 }
      const map_zoom = 4
      const map_markers = ref([])
      const marker_selected = null
      const { showSuccessDialog, showErrorDialog, showConfirmationDialog } = useSwal()
      const { filtered_confined_spaces } = useConfinedSpaces()

      watchEffect(() => {
        if (map_ref.value?.ready) {
          const bounds = new map_ref.value.api.LatLngBounds()

          filtered_confined_spaces.value.map(confined_space => {
            confined_space?.risk_analyses.map((risk_analysis) => {
              if (risk_analysis?.latitude && risk_analysis.longitude) {
                if (
                  risk_analysis.latitude != '' &&
                  risk_analysis.latitude != '.0000000000'
                ) {
                  bounds.extend(
                    new map_ref.value.api.LatLng(
                      risk_analysis.latitude,
                      risk_analysis.longitude,
                    ),
                  )

                  map_markers.value.push({
                    id: risk_analysis.id,
                    position: {
                      lat: parseFloat(risk_analysis.latitude),
                      lng: parseFloat(risk_analysis.longitude),
                    },
                    label: '',
                    title: `Tag Ambra: ${
                      confined_space?.ambra_tag || '-'
                    }\nTag E.C.: ${confined_space?.confined_space_tag || '-'}`,
                  })
                }
              }
            })
          })

          map_ref.value.map.fitBounds(bounds)
          map_ref.value.map.panToBounds(bounds)

          loading.value = false
        }
      })

      return {
        loading,
        map_ref,
        map_center,
        map_zoom,
        map_markers,
        showSuccessDialog,
        showErrorDialog,
        showConfirmationDialog,
        marker_selected,
      }
    },
    methods: {
      selectMarker(marker) {
        this.marker_selected = {
          id: marker.id,
          created_at: format(new Date(), 'dd/MM/yyyy H:m:s'),
        }

        localStorage.setItem(
          'selected_marker_map',
          JSON.stringify(this.marker_selected)
        )
      },

      selectedFirstConfinedSpace() {
        const map = JSON.parse(localStorage.getItem('selected_marker_map'))
        const table = JSON.parse(localStorage.getItem('selected_confined_space_table'))

        if (!table && map) {
          return map
        } else if (!map && table) {
          return table
        } else if (map && table) {
          const dateMap = parseDate(
            map.created_at,
            'dd/MM/yyyy H:m:s',
            new Date(),
          )

          const tableMap = parseDate(
            table.created_at,
            'dd/MM/yyyy H:m:s',
            new Date(),
          )

          if (compareAsc(dateMap, tableMap)) {
            return map
          }

          return table
        }

        return null
      },

      setNewPositionMarker(event) {
        this.marker_selected = this.selectedFirstConfinedSpace()

        if (this.marker_selected) {
          const data = {
            id: this.marker_selected.id,
            confined_space_id: this.marker_selected.confined_space_id,
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          }

          this.showConfirmationDialog(
            'Tem certeza desta operação?',
            'Esta ação irá alterar a localização do espaço confinado.',
            'warning',
          ).then(response => {
            if (!response) return

            this.axios
              .post('/api/confined_spaces/geo', data)
              .then(res => {
                if (!res) return
                
                this.map_markers.map((item, index) => {
                  if (item.id === res.id) {
                    this.map_markers[index].position.lat = res.latitude
                    this.map_markers[index].position.lng = res.longitude
                  }
                })

                this.showSuccessDialog()

                setTimeout(() => {
                  location.reload()
                }, 1500)
              })
              .catch(error => {
                if (error) {
                  this.showErrorDialog(`
                    <small style="color:red">${error.message}</small>
                  `)
                }
              })

            localStorage.removeItem('selected_marker_map')
            localStorage.removeItem('selected_confined_space_table')
          })
        }
      },

      backToMap() {
        $('.to-map').click(function () {
          $('html, body').animate(
            {
              scrollTop: $('.map-container').offset().top - 50,
            },
            500,
          )
        })
      },
    },
    mounted() {
      localStorage.removeItem('selected_marker_map')
      localStorage.removeItem('selected_confined_space_table')
    },
  }
</script>
